//=====================================================
//　G999：システムエラー
//=====================================================

import { useEffect } from "react";
import { useContext } from "react";
import { ContentsBox } from "../../common/ContentsBox";
import { ConstMsg } from "../../utils/ConstMsg";
import { CtxClinicInfo, CtxSystemErr } from "../../utils/Contexts";

export function G999(){

    const cci = useContext(CtxClinicInfo);
    const cserr = useContext(CtxSystemErr);

    //エラーメッセージの設定
    let errmess:string = ConstMsg.EG9990002;
    if (cserr.errmess){
        errmess = cserr.errmess;
    }

    //画面を離れる際にエラーメッセージを初期化する
    useEffect(function(){
        // タイトル追加処理
        if(cci.data.name){
            document.title = cci.data.name + " | Web予約 - システムエラー";
        }else{
            document.title = process.env.REACT_APP_DEFAULT_CLININC_NAME + " | Web予約 - システムエラー";
        }

        return function(){
            cserr.setErrmess("");
        }
        // アンマウント時にのみ一回だけ実行したいため、cserrは第2引数から除外する
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ContentsBox>
            {errmess}
        </ContentsBox>
    );

}